import { ReactComponent as Logo } from './Images/logo.svg';
import { ReactComponent as SmallLogo } from './Images/logo_small.svg';

import { isMobile } from 'react-device-detect';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import React, { Fragment, useEffect } from 'react';
import { Redirect, Switch, Route, useParams, useLocation } from 'react-router-dom';

import CookieConsent from 'react-cookie-consent';

import { AppBar, IconButton, Typography, Toolbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import MuiAlert from '@material-ui/lab/Alert';
import DialogWithEnterAction from './components/DialogWithEnterAction';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import { CompareGCFirmwares, CompareWifiFirmwares } from './Utils/firmware_utils.js';
import { installBrowserConnectionLifecycle } from './Utils/browser_connection_lifecycle.js';
import { ControllerForAlarm } from './Utils/alarm_utils.js';
import _ from 'lodash';

import { useTranslation } from 'react-i18next';

import i18next from 'i18next';

import { Helmet } from 'react-helmet';

import MainMenu from './Menus/MainMenu';
import UserMenu from './Menus/UserMenu';
import { CheckForControllerExists } from './Pages/ControllerPage';
import ManagePage from './Pages/ManagePage';
import AccountPage from './Pages/Account';
import LoginPage from './Pages/LoginPage';
import ResetPage from './Pages/ResetPage';
import UserManagePage from './Pages/UserManagePage';
import RegistrationPage from './Pages/RegistrationPage.js';
import SetupPage from './Pages/SetupPage';
import { useAuth } from './Hooks/authHook';
import { useAddress } from './Hooks/addressHook';
import { AddInfo } from './Contents/AddInfo';
import ScheduleStatus from './Tabs/Scheduling/ScheduleStatus';
import { TabInfo } from './Contents/TabInfo';
import AlarmModal from './Contents/Alarms';
import MessagesModal from './Contents/Messages';
import { Error404 } from './components/Error404';
import { ControllerIdentity } from './components/ControllerIdentity';
import FirmwareRecoveryButton from './FormWidgets/FirmwareRecoveryButton';
import ManualFirmwareUpdate from './components/DeveloperTools/ManualFirmwareUpdate';

import { statusColors } from './Constants/constants';

import { LockSliderContext } from './Contexts';

import { AlarmSelect, GenericSelect } from './FormWidgets/Select';
import Description from './FormWidgets/Description';
import { ShowNotificationBanner } from './FormWidgets/NotificationBanner.js';
import { useSnackbar } from 'notistack';

import getStateManager from './StateManager.js';
import { trackId } from './Hooks/useTabController';
import { useSnapshot, proxy } from 'valtio';
import { useProxySelector } from './Hooks/useProxySelector';
import { useFirmwareVersions } from './Hooks/useFirmwareVersions';
import { useTransition } from 'react';

const emptyControllerProxy = proxy({});

// usefull for debugging
console.dump = (v) => console.log(Object.keys({ v })[0], v);

const routes = [
  {
    path: '/',
    exact: true,
    title: 'manage_controllers',
    main: ({ user }) => <ManagePage user={user} />,
    private: true
  },
  {
    path: '/controller/:id',
    title: () => <ControllerName />,
    main: () => <CheckForControllerExists />,
    condition: (controllers) => {
      return controllers.length > 0;
    },
    private: true
  },
  {
    path: '/account',
    title: 'account_settings',
    main: ({ user, setUser }) => <AccountPage user={user} setUser={setUser} />,
    private: true
  },
  {
    path: '/users',
    title: 'user_management',
    main: ({ user, setUser }) => <UserManagePage user={user} setUser={setUser} />,
    private: true
  },
  {
    path: '/login',
    title: 'login',
    main: () => <LoginPage />,
    private: false
  },
  {
    path: '/register',
    title: 'register',
    main: () => <RegistrationPage />,
    private: false
  },
  {
    path: '/reset',
    title: 'password_reset',
    main: () => <ResetPage />,
    private: false
  },
  {
    path: '/setup',
    title: 'mode_setup',
    main: () => <SetupPage />,
    private: false
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  title: {
    gridColumn: 2,
    justifySelf: 'center',
    maxWidth: '40vw',
    minWidth: 0,
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    zIndex: 2
  },
  black: {
    backgroundColor: theme.palette.appbar_bg
  },
  compact_toolbar: {
    minHeight: 56,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  mobile_menu_icon: {
    fontSize: 26
  },
  mobile_logo: {
    flexShrink: 0,
    height: 18,
    width: 'auto'
  },
  add_info: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    color: theme.palette.primary.main,
    fontSize: '1.1em',
    fontWeight: 500,
    gridColumn: 3,
    justifySelf: 'end',
    marginRight: 30,
    maxWidth: 'calc(100% - 30px)',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  tab_info: {
    color: theme.palette.primary.main,
    fontSize: '1.1em',
    fontWeight: 500,
    gridColumn: 1,
    justifySelf: 'start',
    marginLeft: 30,
    maxWidth: 'calc(100% - 30px)',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  info_container: {
    alignItems: 'center',
    display: 'grid',
    flexGrow: 1,
    gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)'
  },
  compact_toolbar_mobile: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    marginTop: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    width: '100%'
  },
  title_mobile: {
    alignSelf: 'center',
    lineHeight: 1.1,
    maxWidth: '100%',
    paddingBottom: theme.spacing(0.5),
    paddingTop: 0,
    width: '100%'
  },
  mobile_info_row: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    paddingBottom: 4,
    width: '100%'
  },
  tab_info_mobile: {
    color: theme.palette.primary.main,
    fontSize: '1.0em',
    fontWeight: 500,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  add_info_mobile: {
    color: theme.palette.primary.main,
    fontSize: '1.0em',
    fontWeight: 500
  },
  header_readout: {
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit'
  },
  mobile_readout: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minWidth: 0
  },
  appbarSpacer: {
    height: 'var(--app-header-height, 64px)'
  }
}));

export function App({ currTheme, toggleTheme }) {
  let { t } = useTranslation();
  const address = useAddress();
  const auth = useAuth();
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm')) || isMobile;
  const header = React.useRef(null);
  React.useLayoutEffect(() => {
    const root = document.documentElement;
    const previous = root.style.getPropertyValue('--app-header-height');
    const measure = () => root.style.setProperty('--app-header-height', `${header.current.getBoundingClientRect().height}px`);
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(header.current);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
      if (previous) root.style.setProperty('--app-header-height', previous);
      else root.style.removeProperty('--app-header-height');
    };
  }, [mobile]);

  // User
  const [user, setUser] = React.useState({});

  // Snackbar
  const [open, setOpen] = React.useState(false);
  const { messageInfo, setMessageInfo } = React.useState(undefined);
  const handleExited = () => {
    setMessageInfo(undefined);
  };
  let { enqueueSnackbar } = useSnackbar();

  // language
  const [lang, setLang] = React.useState('de');

  // Close dialogs
  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  // Genral state.
  const [state, setState] = React.useState({
    showMainMenu: false,
    showUserMenu: false,
    userMenuAnchor: null
  });

  // ----- set-up global connection. ----- //

  const [no_connection, setNoConnection] = React.useState(false);

  // stateManager, everything in here is controller related (for now)
  const stateManager = getStateManager();
  const wsManager = stateManager.wsManager;
  const authenticatedUser = auth.user;
  const validateSession = auth.validateSession;

  useEffect(() => {
    return installBrowserConnectionLifecycle({
      getWsManager: () => stateManager.wsManager,
      getSimulation: () => stateManager.simulation,
      authenticatedUser,
      validateSession,
      retryInitialization: () => {
        if (!stateManager.controllers_loaded) stateManager.refreshControllerMetadata();
        if (process.env.REACT_APP_SKIP_LOGIN !== 'true')
          stateManager.loadAlarmCatalog(address.api_url('/api/alarms-catalog'));
      }
    });
  }, [authenticatedUser, validateSession, stateManager, wsManager]);

  React.useEffect(() => {
    if (auth.user) {
      // wasm.then((wasm) => {
      // pass non-valtio native react hooks
      stateManager.init(undefined, address, {
        enqueueSnackbar: enqueueSnackbar,
        setNoConnection: setNoConnection,
        t: t,
        onAuthenticationFailed: auth.invalidateSession,
        validateSession: auth.validateSession,
        onControllerDataLoaded: process.env.REACT_APP_SKIP_LOGIN === 'true' ? undefined : (json) => {
          json.controller.forEach((c) => stateManager.addController(
            c, auth.user,
            json.access_rights?.per_controller ?? (c.api_version <= 'ADED' ? 'all' : 'none')
          ));
          const account_language = json.language;
          setLang(account_language);
          setUser({
            name: auth.user,
            email: json.email,
            telegram: json.telegram,
            alarm_email_enabled: json.alarm_email_enabled,
            language: account_language,
            admin: json.admin,
            sub_users: json.admin ? json.sub_users : {},
            access_rights: json.access_rights,
            _2fa_enabled: json._2fa_enabled,
            messages: json.messages
          });
          stateManager.alarms.activeAlarms = json.alarms.map((alarm) => ({
            ...alarm, controller: ControllerForAlarm(stateManager.controllers, alarm)
          }));
          stateManager.loadAlarmCatalog(address.api_url('/api/alarms-catalog'));
        }
      });

      if (process.env.REACT_APP_SKIP_LOGIN !== 'true') {
        stateManager.loadAlarmCatalog(address.api_url('/api/alarms-catalog'));
      }

      if (process.env.REACT_APP_SKIP_LOGIN === 'true') {
        stateManager.addController(
          {
            internal_id: 'local',
            id: 'local',
            name: 'local',
            simulation: false,
            mac_adress: '1-1-1-1',
            type: 6000
          },
          auth.user,
          'all'
        );
        setLang('de');
        setUser({ name: auth.user, email: 'local@mail.de', language: 'de' });
        stateManager.controllers_loaded = true;
      } else {
        stateManager.refreshControllerMetadata();
      }
      // });
    }
    return () => {
      stateManager.cancelControllerMetadataRefresh();
      stateManager.wsManager?.suspend?.('session-cleanup');
      stateManager.simulation?.stop?.();
    };
  }, [auth.invalidateSession, auth.user, auth.validateSession]);

  // Set language
  useEffect(() => {
    // If no local language is set, update local language to account-language.
    const account_language = user.language;
    let session_language = localStorage.getItem('i18nextLng') || account_language || 'de';
    if (session_language === 'undefined' || session_language === 'null')
      session_language = account_language;
    // Update local-storage and current session-language with the set language.
    i18next.changeLanguage(session_language);
    setLang(session_language);
  }, [user]);

  const toggleMainMenu = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setState((prev) => ({ ...prev, showMainMenu: open }));
  };

  const toggleUserMenu = (open) => (event) => {
    event.stopPropagation();
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setState((prev) => ({
      ...prev,
      showUserMenu: open,
      userMenuAnchor: open ? event.currentTarget : null
    }));
  };

  const closeNavigationMenus = () => {
    setState((prev) => ({
      ...prev,
      showMainMenu: false,
      showUserMenu: false,
      userMenuAnchor: null
    }));
  };

  const closeNoConnectionInfoDialog = () => {
    setOpen(false);
  };

  const [open_developer_tools, setOpenDeveloperTools] = React.useState(false);
  const closeDeveloperOptions = () => {
    setOpenDeveloperTools(false);
  };
  const openDeveleloperOptions = React.useCallback((event) => {
    if (
      event.key === 'F4' &&
      !event.altKey &&
      !event.ctrlKey &&
      !event.metaKey &&
      !event.shiftKey &&
      !event.repeat
    ) {
      event.preventDefault();
      setOpenDeveloperTools(true);
    }
  }, []);
  useEffect(() => {
    document.addEventListener('keydown', openDeveleloperOptions, false);
    return () => {
      document.removeEventListener('keydown', openDeveleloperOptions, false);
    };
  }, []);

  const [lockSliderSetting, setLockSliderSetting] = React.useState(
    localStorage.getItem('lockSliderSetting') || 'auto'
  );
  useEffect(() => {
    localStorage.setItem('lockSliderSetting', lockSliderSetting);
  }, [lockSliderSetting]);

  const location = useLocation();
  const controllerIdRegex = /^\/controller\/([^/]+)/;
  const tabIdRegex = /^\/controller\/[^/]+\/zones\/[^/]+\/([^/]+)/;
  const tabIdWithoutZoneRegex = /^\/controller\/[^/]+\/([^/]+)$/;
  const zoneIdRegex = /^\/controller\/[^/]+\/zones\/([^/]+)/;

  const controllerSelected = controllerIdRegex.test(location.pathname);

  // App re-renders only when the routed controller proxy is added, removed or
  // replaced. Live data is subscribed to by the header components below, so it
  // does not re-render App and every open tab with it.
  const routedControllerId = location.pathname.match(controllerIdRegex)?.[1];
  // Tracks proxy identity, which a snapshot cannot: a controller registered again
  // under the same id (e.g. a simulation) must replace the one passed to the tree.
  const controller = useProxySelector(
    stateManager.controllers,
    (controllers) =>
      routedControllerId === undefined
        ? undefined
        : controllers.find((c) => c.id === routedControllerId),
    [routedControllerId]
  );
  // Get controller id from route if available
  let tab_id;
  let zone_id;

  if (controllerSelected) {

    // Try zone-based pattern first
    const tabMatchWithZone = location.pathname.match(tabIdRegex);
    if (tabMatchWithZone) {
      tab_id = tabMatchWithZone[1];
    } else {
      // Try non-zone-based pattern next
      const tabMatchWithoutZone = location.pathname.match(tabIdWithoutZoneRegex);
      if (tabMatchWithoutZone) {
        tab_id = tabMatchWithoutZone[1];
      }
    }

    const zoneMatch = location.pathname.match(zoneIdRegex);
    if (zoneMatch) {
      zone_id = zoneMatch[1];
    }
  }

  const classes = useStyles();
  // const isXS = useMediaQuery((theme) => theme.breakpoints.down('sm')); TODO (fux): is this needed?
  return (
    <Fragment>
      <Helmet htmlAttributes={{ lang: lang }}>
        <meta http-equiv="content-language" content={lang} />
      </Helmet>

      {/* End Normal firmware update */}
      <>
        <AppBar ref={header} id="app-header" className={classes.black} position="fixed" color="secondary">
          <Toolbar {...(mobile && { className: classes.compact_toolbar })}>
            <IconButton edge="start" onClick={toggleMainMenu(true)} color="inherit" aria-label="menu">
              <MenuIcon className={mobile ? classes.mobile_menu_icon : undefined} />
            </IconButton>
            <Fragment>
              {mobile ? (
                <SmallLogo className={classes.mobile_logo} fill="#ffffff" />
              ) : (
                <Logo height={16} fill="#ffffff" />
              )}
              <div className={classes.info_container}>
                {!mobile && (
                  <TabInfo
                    className={classes.tab_info}
                    zone_id={zone_id}
                    tab_id={tab_id}
                    controller={controller}
                  />
                )}
                {!mobile && <PageTitle stateManager={stateManager} />}
                {!mobile && (
                  <HeaderAddInfo
                    className={classes.add_info}
                    readoutClassName={classes.header_readout}
                    controller={controller}
                    zone_id={zone_id}
                  />
                )}
              </div>
              <MessagesModal logged_in={auth.user !== null} />
              <AlarmModal logged_in={auth.user !== null} />
            </Fragment>
          </Toolbar>
          {mobile && (
            <Toolbar className={classes.compact_toolbar_mobile}>
              <PageTitle stateManager={stateManager} mobile />
              {controllerSelected && (
                <div className={classes.mobile_info_row}>
                  <TabInfo
                    className={classes.tab_info_mobile}
                    zone_id={zone_id}
                    tab_id={tab_id}
                    controller={controller}
                  />
                  <HeaderAddInfo
                    className={`${classes.mobile_readout} ${classes.add_info_mobile}`}
                    readoutClassName={classes.header_readout}
                    controller={controller}
                    zone_id={zone_id}
                  />
                </div>
              )}
            </Toolbar>
          )}
        </AppBar>
        <div className={classes.appbarSpacer} />
        {auth.user &&
          user.messages !== undefined &&
          Object.entries(user.messages).map(
            ([message, show]) =>
              show &&
              message !== 'message_telegram_group' && (
                <ShowNotificationBanner key={message} message={t(message)} user={user} />
              )
          )}
        {/* Recovery firmware update */}
        {/* End Recovery firmware update */}
        {/* Normal firmware update */}
        <FirmwareBanners controller={controller} />
      </>
      <NoConnectionInfoDialog open={no_connection} handleClose={closeNoConnectionInfoDialog} />
      <DeveloperTools
        open={open_developer_tools}
        handleClose={closeDeveloperOptions}
        controller={auth.user ? controller : undefined}
      />
      <MainMenu
        open={state.showMainMenu}
        onClose={toggleMainMenu(false)}
        currTheme={currTheme}
        toggleTheme={toggleTheme}
        toggleUserMenu={toggleUserMenu}
        onNavigate={closeNavigationMenus}
        setLang={setLang}
        lockSliderSetting={lockSliderSetting}
        setLockSliderSetting={setLockSliderSetting}
      />
      <UserMenu
        open={state.showUserMenu}
        onClose={toggleUserMenu(false)}
        onNavigate={closeNavigationMenus}
        anchor={state.userMenuAnchor}
        user={user}
      />
      <LockSliderContext.Provider value={lockSliderSetting}>
        <MainContent
          stateManager={stateManager}
          user={user}
          setUser={setUser}
          wsManager={wsManager}
        />
      </LockSliderContext.Provider>
      <Snackbar
        key={messageInfo ? messageInfo.key : undefined}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionProps={{ onExited: handleExited }}
        action={
          <React.Fragment>
            <IconButton aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </React.Fragment>
        }
      >
        <Alert onClose={handleClose} severity={messageInfo ? messageInfo.type : undefined}>
          {messageInfo ? messageInfo.message : undefined}
        </Alert>
      </Snackbar>
      <CookieConsent
        buttonText={t('cookie_consent_button')}
        buttonStyle={{ backgroundColor: statusColors.good, color: '#000000', fontWeight: 700 }}
      >
        {t('cookie_consent')}
      </CookieConsent>
      <div style={{ display: 'flex', justifyContent: 'right', margin: '20px' }}>
        <Description id="pre_release_notice" />
      </div>
    </Fragment>
  );
}

// Header clock and phase, which change every second, and the schedule status.
function HeaderAddInfo({ className, readoutClassName, controller, zone_id }) {
  const controllerSnapshot = useSnapshot(controller ?? emptyControllerProxy);
  const parentSnapshot = controller ? getStateManager().getParent(controllerSnapshot, zone_id) : undefined;
  // ScheduleStatus subscribes on its own and needs the proxy.
  const parent = controller ? getStateManager().getParent(controller, zone_id) : undefined;
  return (
    <div className={className}>
      <AddInfo
        className={readoutClassName}
        time={parentSnapshot?.infos?.time}
        phase={parentSnapshot?.infos?.phase}
      />
      {parent && parentSnapshot?.settings && (
        <ScheduleStatus controller={controller} parent={parent} className={readoutClassName} />
      )}
    </div>
  );
}

function FirmwareBanners({ controller }) {
  const { t } = useTranslation();
  const auth = useAuth();
  const controllerSnapshot = useSnapshot(controller ?? emptyControllerProxy);
  const status = controller ? controllerSnapshot.connection?.status : undefined;

  const firmware_versions = useFirmwareVersions(status);

  const updatable =
    auth.user &&
    controller !== undefined &&
    [5055, 5053, 5052].includes(controllerSnapshot.type) &&
    status === 'good' &&
    controllerSnapshot.simulation !== undefined &&
    !controllerSnapshot.simulation;
  return (
    <>
      {/* Main controller */}
      {updatable && CompareGCFirmwares(controllerSnapshot, firmware_versions) && (
        <ShowNotificationBanner
          message={t('gc_firmware_update_notification_bar_text')}
          to={`/controller/${controllerSnapshot.id}/system#firmware`}
        />
      )}
      {/* Wi-Fi module */}
      {updatable && CompareWifiFirmwares(controllerSnapshot, firmware_versions) && (
        <ShowNotificationBanner
          message={t('wifi_firmware_update_notification_bar_text')}
          to={`/controller/${controllerSnapshot.id}/system#firmware`}
        />
      )}
    </>
  );
}

function NoConnectionInfoDialog({ open, handleClose }) {
  let { t } = useTranslation();
  const style = {
    marginBottom: 20
  };
  const refresh = () => {
    window.location.reload();
  };
  return (
    <DialogWithEnterAction
      open={open}
      onClose={handleClose}
      onEnterAction={refresh}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{t('no_server_connection_msg_title')}</DialogTitle>
      <DialogContent style={style}>{t('no_server_connection_msg_body')}</DialogContent>
      <DialogActions>
        <Button onClick={refresh} color="primary">
          {t('refresh')}
        </Button>
      </DialogActions>
    </DialogWithEnterAction>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ControllerName({ ...props }) {
  let { id } = useParams();
  const stateManager = getStateManager();

  // Snapshot: name and connection status change while the page is open.
  const controller = useSnapshot(stateManager.controllers).find((c) => c.id === id);

  return <ControllerIdentity controller={controller} />;
}

function PageTitle({ stateManager, mobile = false, ...props }) {
  let { t } = useTranslation();
  const classes = useStyles();

  let controllers = useSnapshot(stateManager.controllers);

  return (
    <Switch>
      {routes.map(
        (route, index) =>
          (route.condition !== undefined ? route.condition(controllers) : true) && (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              children={
                <Typography
                  className={`${classes.title}${mobile ? ` ${classes.title_mobile}` : ''}`}
                  variant="h6"
                >
                  {typeof route.title === 'function' ? (
                    <route.title controllers={controllers} />
                  ) : (
                    t(route.title)
                  )}
                </Typography>
              }
            />
          )
      )}
    </Switch>
  );
}

function MainContent({ stateManager, user, setUser, ...other }) {
  const address = useAddress();
  const auth = useAuth();
  const controllers = useSnapshot(stateManager.controllers);
  return (
    <Switch>
      {routes.map(
        (route, index) =>
          (route.condition !== undefined && auth.user ? route.condition(controllers) : true) && (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              children={({ location }) =>
                !route.private || auth.user ? (
                  <route.main user={user} setUser={setUser} />
                ) : process.env.REACT_APP_STATIC_USING_APP === 'true' && address.api === '' ? (
                  <Redirect to={{ pathname: '/setup', state: { from: location } }} />
                ) : auth.sessionPending ? (
                  <CircularProgress />
                ) : (
                  <Redirect to={{ pathname: '/login', state: { from: location } }} />
                )
              }
            />
          )
      )}
      <Route path="*">
        <Error404 />
      </Route>
    </Switch>
  );
}

function DeveloperTools({ open, handleClose, controller }) {
  const [alarm, setAlarm] = React.useState({ name: 'all', value: 90 });
  const [zone, setZone] = React.useState({ id: 0xff, name: '' });
  const simulation = getStateManager().simulation;
  const { t } = useTranslation();
  // Snapshot: App does not re-render on controller changes while this is open.
  const controllerSnapshot = useSnapshot(controller ?? emptyControllerProxy);
  trackId(controllerSnapshot); // nothing else is read while the dialog is closed

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle id="form-dialog-title">Developer Tools</DialogTitle>
      <DialogContent>
        <FirmwareRecoveryButton controller={controller && controllerSnapshot} onClick={handleClose} />
        <ManualFirmwareUpdate controller={controller} onClose={handleClose} />
        {simulation && (
          <>
            Test alarms:
            <AlarmSelect
              label="alarm-name"
              value={alarm.name}
              onChange={(event) => setAlarm({ ...alarm, name: event.target.value })}
            />
            <TextField
              autoFocus
              margin="dense"
              id="serial"
              label="Value"
              type="number"
              fullWidth
              value={alarm.value}
              onChange={(event) => setAlarm({ ...alarm, value: event.target.value })}
            />
            {simulation.zones.length > 0 && (
              <GenericSelect
                onChange={(evt) => setZone({ id: evt.target.value, name: evt.target.label })}
                values={Object.values(simulation.zones)
                  .map((z) => ({ value: parseInt(z.id), label: z.name }))
                  .concat([
                    { value: 0xfe, label: t('global') },
                    { value: 0xff, label: t('undefined') }
                  ])}
                value={zone}
              />
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        {simulation && (
          <>
            <Button
              onClick={(evt) => simulation.send_alarm(evt, zone.id, zone.name, alarm)}
              color="primary"
            >
              Trigger Alarm
            </Button>
            <Button
              onClick={(evt) => simulation.resolve_alarm(evt, zone.id, zone.name, alarm)}
              color="primary"
            >
              Resolve Alarm
            </Button>
          </>
        )}
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
